<script>
    import { showApiErrorModal } from "../../stores";

    let previousKeyDown = null;

    $: if ($showApiErrorModal) {
        previousKeyDown = document.onkeydown;
        enableCloseWithESC();
    }

    const enableCloseWithESC = () => {
        document.onkeydown = (event) => {
            if (event.key === "Escape") {
                closeModal();
            }
        };
    };

    const closeModal = () => {
        $showApiErrorModal = false;
        document.onkeydown = previousKeyDown ?? null;
    };
</script>

<div class={$showApiErrorModal ? "modal modal-open sm:modal-middle" : "modal"}>
    <div class="modal-box w-1/3 max-w-full p-6">
        <h3 class="font-medium text-lg my-4">Oops...</h3>
        <div class="p4">
            <p class="leading-6 text-error whitespace-pre-line">
                Unable to reach the server, please check your internet
                connection. If everything is ok, please wait 5 seconds and try
                again.
            </p>
            <p class="leading-6 text-error whitespace-pre-line">
                Contact support if the issue persists.
            </p>
        </div>

        <div class="modal-action flex-1 justify-end gap-x-6">
            <button
                class="w-32 btn btn-error text-white text-[14px] rounded-xl"
                on:click={closeModal}
            >
                Close
            </button>
        </div>
    </div>
</div>
